export enum TemplateType {
  LASSIE = 'lassie',
  LASSIE_MINI = 'lassieMini',
  SHUTTLE_RACK = 'shuttleRack',
}
